import { LOCATION_INITIALIZED } from '@angular/common';
import { Injectable, Injector } from '@angular/core';

import { SnEnvService } from '@insight/serenity-env';
import { SnAuthModule } from '@insight/serenity-auth';
import { SnScaffoldingModule } from '@insight/serenity-scaffolding';
//import { SerenityNgxModule } from '@insight/serenity-ngx';

export function preInitServiceFactory(
    initService: PreInitService,
    injector: Injector
) {
    return () =>
        new Promise(resolve =>
            injector
                .get(LOCATION_INITIALIZED, Promise.resolve(undefined))
                .then(() => resolve(initService.onInit()))
        );
}

@Injectable()
export class PreInitService {
    constructor(private readonly envService: SnEnvService) {}

    async onInit(): Promise<boolean> {
        try {
            const e = await this.envService.bootstrap();

            SnAuthModule.setConfig({
                apiRoot: e.core_api_url,
                oktaConfiguration: {
                    clientId: e.okta.clientId,
                    issuer: e.okta.issuer,
                    redirectUri: `${window.location.origin}/implicit/callback`,
                    scopes: ['openid', 'profile', 'email']
                }
            });

            // Scaffolding configuration
            SnScaffoldingModule.setConfig({
                apiRoot: e.core_api_url
            });  

            console.log('env.json loaded');
            return true;
        } catch (error) {
            console.error('Error loading application configuration', error);
            return Promise.resolve(false);
        }
    }
}
